var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chartWrap",staticClass:"chart-wrap"},[_c('div',{ref:"chart"}),_c('div',{staticClass:"chart-total font-weight-semi-bold text-uppercase",style:({'font-size': _vm.fontSizeComputed })},[_vm._v(_vm._s(_vm.chartData.total))])])}
var staticRenderFns = []

export { render, staticRenderFns }